import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SquareCheckBox = styled.div<{ active?: boolean }>`
  position: relative;
  width: 1rem;
  height: 1rem;
  padding: 2px;
  border: 1px solid ${tokens.accent.base};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.active ? tokens.accent.base : 'transparent')};
`

export const CheckChipContainer = styled.div<{ active?: boolean }>`
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.chip};
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 5px 10px;
  ${(props) => props.active && `border:1px solid ${tokens.accent.base};`}
  cursor: pointer;
`

export const ChipsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`
